var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.87C12.63 6.87 13.56 5.94 13.56 4.8C13.56 3.67 12.63 2.75 11.5 2.75C10.36 2.75 9.43 3.67 9.43 4.8C9.43 5.94 10.36 6.87 11.5 6.87Z",
    fill: "#2A2A2A",
    fillOpacity: 0.5,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.87C10.36 6.87 9.43 5.94 9.43 4.8C9.43 3.67 10.36 2.75 11.5 2.75C12.63 2.75 13.56 3.67 13.56 4.8C13.56 5.94 12.63 6.87 11.5 6.87Z",
    stroke: "#2A2A2A",
    strokeOpacity: 0,
    strokeWidth: 1,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.06C12.63 14.06 13.56 13.13 13.56 12C13.56 10.86 12.63 9.94 11.5 9.94C10.36 9.94 9.43 10.86 9.43 12C9.43 13.13 10.36 14.06 11.5 14.06Z",
    fill: "#2A2A2A",
    fillOpacity: 0.5,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.06C10.36 14.06 9.43 13.13 9.43 12C9.43 10.86 10.36 9.94 11.5 9.94C12.63 9.94 13.56 10.86 13.56 12C13.56 13.13 12.63 14.06 11.5 14.06Z",
    stroke: "#2A2A2A",
    strokeOpacity: 0,
    strokeWidth: 1,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.25C12.63 21.25 13.56 20.32 13.56 19.18C13.56 18.05 12.63 17.12 11.5 17.12C10.36 17.12 9.43 18.05 9.43 19.18C9.43 20.32 10.36 21.25 11.5 21.25Z",
    fill: "#2A2A2A",
    fillOpacity: 0.5,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.25C10.36 21.25 9.43 20.32 9.43 19.18C9.43 18.05 10.36 17.12 11.5 17.12C12.63 17.12 13.56 18.05 13.56 19.18C13.56 20.32 12.63 21.25 11.5 21.25Z",
    stroke: "#2A2A2A",
    strokeOpacity: 0,
    strokeWidth: 1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots-icon.c3ceff52a01a4bcc1e4b261779a51162.svg";
export { ForwardRef as ReactComponent };